import React, { useState } from "react";
import { useI18n } from "../I18nProvider";
import { FORMULAR_URL } from "../formularZiel";
import FormMeldung from "./FormMeldung";

export default function GeneralForm() {
  const { t } = useI18n();
  const tr = (key, vars) => {
    let s = t(key);
    if (vars) {
      Object.keys(vars).forEach((k) => {
        s = s.replace(new RegExp(`\\{${k}\\}`, "g"), String(vars[k]));
      });
    }
    return s;
  };

  // Die Discord-Adressen stehen NICHT mehr hier, sondern nur noch beim
  // Vermittler (siehe worker/). Erlaubt sind diese drei Stichwoerter:
  // "recht" (Vertrag & Papiere) wurde mit "zoll" zusammengelegt: beide Knoepfe
  // versprachen "Papiere", das war fuer den Besucher nicht unterscheidbar.
  // Der Discord-Kanal WEBHOOK_RECHT bleibt bestehen, wird nur nicht mehr bedient.
  const ZIELE = ["zoll", "sonstiges"];

  const [formData, setFormData] = useState({
    topic: "",
    name: "",
    email: "",
    phone: "",
    location: "",
    land: "",
    message: "",
    webseite: "", // Koeder, siehe Formularende
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [hinweis, setHinweis] = useState(null);

  function handleChange(e) {
    const { name, type, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  }

  function validate() {
    if (!formData.topic) return t("generalform.err_topic");
    if (!formData.name?.trim()) return t("generalform.err_name");
    if (!formData.location?.trim()) return t("generalform.err_location");
    if (!formData.land) return t("generalform.err_land");
    // Telefon ODER E-Mail genuegt (siehe CarForm)
    if (!formData.email?.trim() && !formData.phone?.trim())
      return t("carform.err_kontaktweg");
    return null;
  }

  function topicLabel(topic) {
    switch (topic) {
      case "zoll":
        return t("generalform.topic_zoll");
      default:
        return t("generalform.topic_sonstiges");
    }
  }

  function buildDiscordEmbed() {
    const label = topicLabel(formData.topic);
    const fields = [
      { name: t("generalform.field_topic"), value: label, inline: false },
      { name: t("generalform.field_name"), value: formData.name || "-", inline: true },
      { name: t("generalform.field_phone"), value: formData.phone || "-", inline: true },
      { name: t("generalform.field_email"), value: formData.email || "-", inline: true },
      { name: t("generalform.field_location"), value: formData.location || "-", inline: true },
      { name: t("carform.field_land"), value: formData.land ? t(`carform.land_${formData.land}`) : "-", inline: true },
    ];
    if (formData.message?.trim()) {
      fields.push({ name: t("generalform.field_message"), value: formData.message.trim(), inline: false });
    }
    return {
      title: tr("generalform.embed_title", { topic: label }),
      color: 0x1a3a5f,
      fields,
      timestamp: new Date().toISOString(),
    };
  }

  async function postToDiscord(embed, topic) {
    if (!ZIELE.includes(topic)) throw new Error(t("generalform.err_webhook"));

    const fd = new FormData();
    fd.append("ziel", topic);
    fd.append("webseite", formData.webseite);
    const payload = {
      username: "AUTO M.A.H. Kontaktformular",
      content: tr("generalform.discord_content", { topic: embed.fields[0].value }),
      embeds: [embed],
    };
    fd.append("payload_json", JSON.stringify(payload));

    const res = await fetch(FORMULAR_URL, { method: "POST", body: fd });
    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(text || t("generalform.err_webhook"));
    }
  }

  async function onSubmit(e) {
    e.preventDefault();
    const formEl = e.currentTarget;

    const error = validate();
    if (error) {
      setHinweis({ typ: "fehler", text: error });
      return;
    }

    setHinweis(null);
    setIsSubmitting(true);
    try {
      const embed = buildDiscordEmbed();
      await postToDiscord(embed, formData.topic);
      setHinweis({ typ: "ok", text: t("generalform.success_alert") });

      formEl.reset();
      setFormData({
        topic: "",
        name: "",
        email: "",
        phone: "",
        location: "",
        land: "",
        message: "",
          });
    } catch (err) {
      console.error(err);
      setHinweis({ typ: "fehler", text: t("generalform.err_generic") });
    } finally {
      setIsSubmitting(false);
    }
  }

  const styles = {
    form: { margin: "0 auto", padding: 16, border: "1px solid #ddd", borderRadius: 8, color: "black" },
    section: { marginBottom: 24 },
    grid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 16 },
    full: { gridColumn: "1 / -1" },
    label: { display: "block", fontWeight: 600, marginBottom: 6 },
    input: { width: "100%", padding: 10, border: "1px solid #ccc", borderRadius: 6 },
    textarea: { width: "100%", padding: 10, border: "1px solid #ccc", borderRadius: 6, minHeight: 80 },
    h4: { marginBottom: 8 },
    button: {
      padding: "12px 18px",
      border: "none",
      borderRadius: 8,
      background: isHovered ? "#b8941f" : "#d4af37",
      color: "#fff",
      cursor: "pointer",
      fontWeight: 600,
      opacity: isSubmitting ? 0.7 : 1,
    },
    checkboxLabel: { display: "flex", gap: 8, alignItems: "flex-start", cursor: "pointer" },
  };

  return (
    <div className="purchase-form" style={styles.form}>
      <form id="contactForm" onSubmit={onSubmit} noValidate>
        <div className="form-section" style={styles.section}>
          <h4 style={styles.h4}>{t("generalform.heading_intro")}</h4>

          <div className="form-group">
            <span style={styles.label}>{t("generalform.topic_label")}</span>
            {/* Frueher ein Klappmenue: die drei Moeglichkeiten waren versteckt,
                man musste erst oeffnen. Jetzt liegen sie offen als Karten -
                gleiche Bedienung wie die Service-Wahl im Ankauf-Formular. */}
            <div className="anliegen-wahl">
              {[
                // Ankauf zuerst: das ist das Hauptgeschaeft. Die beiden
                // oeffnen das richtige Formular statt hier leer anzufragen.
                { wert: "ankauf", symbol: "fa-car-side", oeffnet: "purchase" },
                { wert: "wunschauto", symbol: "fa-magnifying-glass-location", oeffnet: "wish_car" },
                { wert: "zoll", symbol: "fa-passport" },
                { wert: "sonstiges", symbol: "fa-comment-dots" },
              ].map(({ wert, symbol, oeffnet }) => (
                <button
                  type="button"
                  key={wert}
                  className={`anliegen-karte ${oeffnet ? "verweist" : ""} ${
                    formData.topic === wert ? "aktiv" : ""
                  }`}
                  aria-pressed={oeffnet ? undefined : formData.topic === wert}
                  onClick={() => {
                    if (oeffnet) {
                      window.dispatchEvent(
                        new CustomEvent("automah:formular", { detail: oeffnet })
                      );
                    } else {
                      setFormData((prev) => ({ ...prev, topic: wert }));
                    }
                  }}
                >
                  <i className={`fas ${symbol}`} aria-hidden="true"></i>
                  <span className="anliegen-titel">{t(`generalform.topic_${wert}`)}</span>
                  <span className="anliegen-hilfe">
                    {t(`generalform.topic_${wert}_hilfe`)}
                    {oeffnet && <i className="fas fa-arrow-right anliegen-pfeil" aria-hidden="true"></i>}
                  </span>
                </button>
              ))}
            </div>
          </div>

          <h4 style={styles.h4}>{t("generalform.contacts_title")}</h4>
          <div className="form-grid" style={styles.grid}>
            <div className="form-group">
              <label htmlFor="k-name" style={styles.label}>{t("generalform.name_label")}</label>
              <input
                type="text"
                id="k-name"
                name="name"
                placeholder={t("generalform.name_ph")}
                required
                value={formData.name}
                onChange={handleChange}
                style={styles.input}
              />
            </div>

            <div className="form-group">
              <label htmlFor="k-email" style={styles.label}>{t("generalform.email_label")}</label>
              <input
                type="email"
                id="k-email"
                name="email"
                placeholder={t("generalform.email_ph")}
                value={formData.email}
                onChange={handleChange}
                style={styles.input}
              />
            </div>

            <div className="form-group">
              <label htmlFor="k-phone" style={styles.label}>{t("generalform.phone_label")}</label>
              <input
                type="tel"
                id="k-phone"
                name="phone"
                placeholder={t("generalform.phone_ph")}
                value={formData.phone}
                onChange={handleChange}
                style={styles.input}
              />
            </div>

            <div className="form-group">
              <label htmlFor="k-location" style={styles.label}>{t("generalform.location_label")}</label>
              <input
                type="text"
                id="k-location"
                name="location"
                placeholder={t("generalform.location_ph")}
                required
                value={formData.location}
                onChange={handleChange}
                style={styles.input}
              />
            </div>

            {/* Land. Ein Ort allein ist hier nicht eindeutig: Rheinfelden gibt
                es in Deutschland UND in der Schweiz, keine drei Kilometer
                auseinander. Und DE wie FR haben fuenfstellige Postleitzahlen.
                Die Beschriftungen kommen bewusst aus dem Ankauf-Formular,
                damit beide Formulare nie auseinanderlaufen. */}
            <div className="form-group">
              <label htmlFor="k-land" style={styles.label}>{t("carform.land_label")}</label>
              <select
                id="k-land"
                name="land"
                required
                value={formData.land}
                onChange={handleChange}
                style={styles.input}
              >
                <option value="">{t("carform.land_placeholder")}</option>
                <option value="de">{t("carform.land_de")}</option>
                <option value="ch">{t("carform.land_ch")}</option>
                <option value="fr">{t("carform.land_fr")}</option>
                <option value="other">{t("carform.land_other")}</option>
              </select>
            </div>
          </div>

          <div className="form-group" style={styles.full}>
            <label htmlFor="k-message" style={styles.label}>{t("generalform.message_label")}</label>
            <textarea
              id="k-message"
              name="message"
              rows={3}
              placeholder={t("generalform.message_ph")}
              value={formData.message}
              onChange={handleChange}
              style={styles.textarea}
            />
          </div>

          {/* Koederfeld gegen Automaten. Fuer Menschen unsichtbar UND nicht
              erreichbar: auf 1x1 Punkt geschrumpft und weggeschnitten, aus der Tabulator-Reihenfolge
              genommen, fuer Vorleseprogramme ausgeblendet. Ein Mensch kann es
              gar nicht ausfuellen. Ein Automat fuellt blind jedes Feld und
              verraet sich damit. Der Vermittler verwirft solche Anfragen still
              und meldet trotzdem Erfolg, damit der Automat nichts dazulernt. */}
          <div
            aria-hidden="true"
            style={{
              position: "absolute",
              width: 1,
              height: 1,
              margin: -1,
              padding: 0,
              border: 0,
              overflow: "hidden",
              clip: "rect(0 0 0 0)",
              clipPath: "inset(50%)",
              whiteSpace: "nowrap",
            }}
          >
            <label htmlFor="hp-kontakt">Bitte dieses Feld leer lassen</label>
            <input
              type="text"
              id="hp-kontakt"
              name="webseite"
              tabIndex={-1}
              autoComplete="off"
              value={formData.webseite}
              onChange={handleChange}
            />
          </div>

          <div className="form-group" style={styles.full}>
            {/* Kein Pflichthaken: eine Datenschutzerklaerung ist eine Information,
                keine Einwilligung. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b/f DSGVO. */}
            <p style={{ fontSize: 13, lineHeight: 1.55, opacity: 0.85, margin: 0 }}>
              {t("generalform.privacy_prefix")}{" "}
              <a
                href="/privacy"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#d4af37", textDecoration: "underline" }}
              >
                {t("generalform.privacy_link")}
              </a>{" "}
              {t("generalform.privacy_suffix")}
            </p>
          </div>
        </div>

        <FormMeldung hinweis={hinweis} />

        <button
          type="submit"
          className="btn submit-btn"
          style={styles.button}
          disabled={isSubmitting}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {isSubmitting ? t("generalform.btn_sending") : t("generalform.btn_submit")}
        </button>
      </form>
    </div>
  );
}
